import PropTypes from 'prop-types';

/**
 * Amazon Associates disclosure. The Associates Program Operating Agreement
 * requires this exact sentence to be shown clearly on the site; the FTC also
 * expects affiliate links to be disclosed near where they appear. Do not reword
 * the first sentence.
 */
export const ASSOCIATE_DISCLOSURE = 'As an Amazon Associate we earn from qualifying purchases.';

const AffiliateDisclosure = ({ className = '', detail = true }) => (
  <p className={`affiliate-disclosure ${className}`.trim()}>
    {ASSOCIATE_DISCLOSURE}
    {detail && ' Links to Amazon on this site are affiliate links: buying through them costs you nothing extra and supports Lite Pocket Deals. Prices and promo codes can change at any time; the price on Amazon at checkout applies.'}
  </p>
);

AffiliateDisclosure.propTypes = {
  className: PropTypes.string,
  detail: PropTypes.bool,
};

export default AffiliateDisclosure;
